import React from 'react';
import { StyledBannerNews } from './StyledBannerNews';
import { useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const BannerNews = ({ highlightNews, excerpt, slug }) => {

  let history = useHistory();
  
  const dispatch = useDispatch();
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }
  return (
    <React.Fragment>
      {
       
          <StyledBannerNews>
            <div className="banner-news--wrap">
              <div className="banner-news--hero">
                
                <img className="banner-news--hero-bg" src={highlightNews.img_hero} />
                <div className="opacity-banner"></div>
                <div className="banner-news--info">
                  <p className="preset-13 category">{highlightNews.category}</p>
                  <p className="preset-9 title">{highlightNews.title}</p>
                  <div className="row-details">
                    <div className="col-details">
                      <img src={require('../../assets/calendar.svg')} />
                      <p className="preset-12">{highlightNews.date}</p>
                    </div>
                    <div className="col-details">
                      <img src={require('../../assets/time.svg')} />
                      <p className="preset-12">{highlightNews.reading_time} read</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="banner--news--cta-wrap">
                <p className="preset-10 excerpt">{excerpt}</p>
                <div className="cta--primary cursor-cta" onClick={()=> handleCLick(`/news/${slug}`)}>
                <p className="preset-10 cursor-cta" style={{color:'#45B865'}} >Read More</p>
                
                <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke='#45B865' strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path className="cursor-cta" d="M13 6H1" stroke='#45B865' strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                
              </div>
              </div>
            </div>
            
          </StyledBannerNews>
          
      }
    </React.Fragment>
  );
};


export default BannerNews;
